import { useEffect, useState } from "react"

export default function Simulator() {
  const [text, setText] = useState<string>("(로딩 중...)");
  const [connected, setConnected] = useState<boolean>(false);

  console.log(connected)
  
  useEffect(() => {
    const ws = new WebSocket("ws://210.219.33.220:8765");

    ws.onopen = () => setConnected(true);
    ws.onmessage = (e) => setText(e.data as string);
    ws.onclose = () => setConnected(false);
    ws.onerror = () => ws.close(); // 단순 처리

    // 컴포넌트 unmount 시 연결 해제
    return () => ws.close();
  }, []);

  return <div>asdfasdfa</div>
}